import type { ContainerModifierValue } from "schemas/generated/fileModifiers";

import React from "react";

import AppearanceModifier from "./base/AppearanceModifier";
import BackgroundModifierComponent from "./base/BackgroundModifier";
import BorderModifier from "./base/BorderModifier";
import ContainerAlignmentModifierComponent from "./base/ContainerAlignmentModifier";
import DirectionModifierComponent from "./base/DirectionModifier";
import GapModifierComponent from "./base/GapModifier";
import MarginModifierComponent from "./base/MarginModifier";
import PaddingModifierComponent from "./base/PaddingModifier";
import ProductSelectorModifier from "./base/ProductSelectorModifier";
import ModifierLayout from "./ModifierLayout";
import { useSelectedElement } from "./store/ModifiersStoreContext";

interface ContainerModifierBlockProps {
  onModifiersValueChange: (modifiers: ContainerModifierValue[]) => void;
}

const ContainerModifierBlock: React.FC<ContainerModifierBlockProps> = ({
  onModifiersValueChange,
}) => {
  const selectedElement = useSelectedElement();

  const sections = [
    ...(selectedElement?.props?.productId
      ? [
          {
            rows: [
              {
                title: "Product",
                component: (
                  <ProductSelectorModifier onChange={onModifiersValueChange} />
                ),
              },
            ],
          },
        ]
      : []),
    {
      rows: [
        {
          title: "Direction",
          component: (
            <DirectionModifierComponent onChange={onModifiersValueChange} />
          ),
        },
        {
          title: "Alignment",
          component: (
            <ContainerAlignmentModifierComponent
              onChange={onModifiersValueChange}
            />
          ),
        },
      ],
    },
    {
      rows: [
        {
          title: "Gap",
          component: <GapModifierComponent onChange={onModifiersValueChange} />,
        },
      ],
    },
    {
      rows: [
        {
          title: "Padding",
          component: (
            <PaddingModifierComponent onChange={onModifiersValueChange} />
          ),
        },
        {
          title: "Margin",
          component: (
            <MarginModifierComponent onChange={onModifiersValueChange} />
          ),
        },
        {
          title: "Background",
          component: (
            <BackgroundModifierComponent onChange={onModifiersValueChange} />
          ),
        },
      ],
    },
    {
      rows: [
        {
          title: "Border",
          component: <BorderModifier onChange={onModifiersValueChange} />,
        },
      ],
    },
    {
      rows: [
        {
          title: "Appearance",
          component: <AppearanceModifier onChange={onModifiersValueChange} />,
        },
      ],
    },
  ];

  return <ModifierLayout sections={sections} />;
};

export default ContainerModifierBlock;
